import { CirclesWithBar, RotatingSquare } from "react-loader-spinner";
import CustomButtonSimple from "../../../../components/CustomMiscellaneous/CustomButtonSimple";
import DoneIcon from '@mui/icons-material/Done';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { genericGet, genericPost } from "../../../../services/api.service";
import { getButtonIconForState, getButtonTextForState } from "../../utils";
import { TipoOperacao } from "../../../Obras/newObra/IObra";
import toast from "react-hot-toast";
import { useContext } from "react";
import { FactoryFloorContext } from "../../../../contexts/FactoryFloorContext";
import { palette } from "../../../../assets/theme/theme";


export default function PecaParaOperacaoActions({estado, updatePecaState, setPecasToDisplay, data, setRequestMedidasConvencional} :
     {estado: string,
         updatePecaState: (pecaId: string | number) => void,
          setPecasToDisplay: (pecas: any[]) => void,
          data: any,
          setRequestMedidasConvencional: (is: boolean) => void
        }) {

            const { selectionValues } = useContext(FactoryFloorContext);

            console.log("Estado: ", estado);

    const getActionButtons = () => {

        if (estado == 'Por iniciar') {
            return (<CustomButtonSimple
                text={getButtonTextForState(estado)}
                onClick={() => updatePecaState(data.id)}
                Icon={getButtonIconForState(estado)} />)
        } else if (estado == 'Em andamento') {
            return (<div className="flex">
                <CustomButtonSimple
                    text={'Pausar'}
                    onClick={() => pausePecaState(data.id)}
                    Icon={PauseIcon}
                    className={'mr-1 bg-cyan-500'}
                />

                <CustomButtonSimple
                    text={getButtonTextForState(estado)}
                    color={palette.blue.light}
                    onClick={() => {
                        if (selectionValues.operacao == TipoOperacao.CONVENCIONAIS) {
                            setRequestMedidasConvencional(true);
                        } else {
                            updatePecaState(data.id)
                        }
                    }}
                    Icon={getButtonIconForState(estado)}
                    className={'ml-1 bg-lime-700'} />
            </div>)
        } else if (estado == 'Em pausa') {
            return (<CustomButtonSimple
                text={'Resumir'}
                color={palette.blue.light}
                onClick={() => pausePecaState(data.id)}
                Icon={PlayArrowIcon} />)
        } else {
            return null;
        }


    }

    const pausePecaState = async (pecaId: string | number) => {
        try {
            await (genericPost(`/pecas/pause/${pecaId}/${selectionValues.operacao}`))(null);
            const updatedPecas = await genericGet(`/obras/${selectionValues.obra?.id}/entregas/${selectionValues.entrega?.id}/operacoes/${selectionValues.operacao}`)
            setPecasToDisplay(updatedPecas);
            toast.success('Peça pausada/resumida com sucesso!');
        } catch (e) {
            toast.error('Erro ao pausar/resumir peça!');
        }

    }


    return(
        <div className="flex justify-center items-center w-2/5 text-white font-bold">
            {}
                    <div>
                        {estado === 'Em pausa' ? <div className="mb-3">
                            <div className="flex justify-center">
                                <PauseIcon className="text-cyan-500" style={{ fontSize: '8em' }} />
                            </div>
                            <h3>Operações em pausa</h3>
                        </div> : null}
                        {estado === 'Em andamento' ?
                            <div className="mb-4">
                                <div className="flex justify-center ">
                                    <CirclesWithBar
                                        outerCircleColor={palette.rodrimaq_red}
                                        innerCircleColor={"white"}
                                        barColor={palette.rodrimaq_red}
                                    />
                                </div>
                                <div className="flex justify-center mt-3">
                                    <h3>Operações em curso...</h3>
                                </div>
                            </div> : null}
                        {estado === 'Concluído' ? <div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <div>
                                    <DoneIcon className='text-lime-700' style={{ fontSize: '8em' }} />
                                    <h3>Operações concluídas!</h3>

                                    {selectionValues.operacao === TipoOperacao.CONVENCIONAIS ?
                                        <CustomButtonSimple className="mt-5" text="Editar medidas" onClick={() => setRequestMedidasConvencional(true)} />
                                        : null}
                                </div>
                            </div>


                        </div> : null}
                        {getActionButtons()}

                    </div>
                </div>
    )


}